<template>
  <div
    :class="{ dark: isDarkMode }"
    class="min-h-screen font-sans transition-colors duration-300"
  >
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <banner-section />
      <popular-categories-section class="pt-24" :category="categories[0]" />
      <popular-categories-section :category="categories[1]" />
      <company-introduction />
      <Applications />
      <our-certificates />

      <button
        v-show="showScrollTop"
        @click="scrollToTop"
        class="fixed bottom-8 right-8 bg-primary text-white p-3 rounded-full shadow-2xl hover:scale-110 transition-transform flex items-center justify-center"
      >
        <i class="material-icons">arrow_upward</i>
      </button>
    </div>
  </div>
</template>

<script>
import BannerSection from './BannerSection'
import PopularCategoriesSection from './PopularCategoriesSection'
import CompanyIntroduction from './CompanyIntroduction'
import Applications from './Applications'
import OurCertificates from './OurCertificates'
export default {
  components: {
    BannerSection,
    PopularCategoriesSection,
    CompanyIntroduction,
    Applications,
    OurCertificates
  },
  data() {
    return {
      categories: [
        {
          title: 'HTV SILICONE RUBBER',
          message:
            'High Temperature Vulcanized (HTV) Silicone Rubber—also known as Heat-Cured Rubber (HCR)—is is a solid, high-molecular-weight elastomer made from polysiloxane, vulcanizers and fillers. Cured at 110–170°C with heat and pressure via compression or extrusion molding, it forms durable, elastic end products for diverse industries.',
          images: [
            {
              url: require('@/assets/product/Electric Insulation Silicone Rubber.jpg'),
              message: 'Electric Insulation Silicone Rubber'
            },
            {
              url: require('@/assets/product/Fire Retardant Silicone Rubber.jpg'),
              message: 'Fire Retardant Silicone Rubber'
            },
            {
              url: require('@/assets/product/General Purpose Silicone Rubber For Molding.jpg'),
              message: 'General Purpose Silicone Rubber For Molding'
            },
            {
              url: require('@/assets/product/High Resilience Silicone Rubber.jpg'),
              message: 'High Resilience Silicone Rubber'
            },
            {
              url: require('@/assets/product/High Tear Strength Silicone Rubber For Molding.jpg'),
              message: 'High Tear Strength Silicone Rubber For Molding'
            },
            {
              url: require('@/assets/product/High Temperature Resistant Silicone Rubber.jpg'),
              message: 'High Temperature Resistant Silicone Rubber'
            },
            {
              url: require('@/assets/product/High Transparent Fumed Silicone Rubber.jpg'),
              message: 'High Transparent Fumed Silicone Rubber'
            },
            {
              url: require('@/assets/product/Roller Silicone Rubber.jpg'),
              message: 'Roller Silicone Rubber'
            },
            {
              url: require('@/assets/product/Silicone Rubber for Extrusion.jpg'),
              message: 'Silicone Rubber for Extrusion'
            }
          ]
        },
        {
          title: 'LIQUID SILICONE RUBBER',
          message:
            'Liquid Silicone Rubber (LSR), a two-component addition-cure elastomer, cures fast via platinum-catalyzed reaction. Boasting low compression set, wide temperature resistance (-60°C to 200°C) and high precision, it suits seals, medical parts, baby products and kitchenware.',
          images: [
            {
              url: require('@/assets/product/High Transparency Silicone Rubber.jpg'),
              message: 'High Transparency Silicone Rubber'
            },
            {
              url: require('@/assets/product/Liquid Silicone Rubber for  Food Kitchen.jpg'),
              message: 'Liquid Silicone Rubber for  Food Kitchen'
            },
            {
              url: require('@/assets/product/Liquid Silicone Rubber for Baby Care.jpg'),
              message: 'Liquid Silicone Rubber for Baby Care'
            },
            {
              url: require('@/assets/product/Liquid Silicone Rubber for Cable Accessories.jpg'),
              message: 'Liquid Silicone Rubber for Cable Accessories'
            },
            {
              url: require('@/assets/product/Liquid Silicone Rubber for Medical.jpg'),
              message: 'Liquid Silicone Rubber for Medical'
            },
            {
              url: require('@/assets/product/Liquid Silicone Rubber for Molding.jpg'),
              message: 'Liquid Silicone Rubber for Molding'
            },
            {
              url: require('@/assets/product/Self-Adhesive Liquid Silocone Rubber.jpg'),
              message: 'Self-Adhesive Liquid Silocone Rubber'
            }
          ]
        }
      ],
      isDarkMode: false,
      showScrollTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showScrollTop = window.scrollY > 400
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style>
/* 可以在此处添加自定义动画 */
.font-serif {
  font-family: 'Playfair Display', serif;
}
</style>



// WEBPACK FOOTER //
// src/page/index/Index.vue